module.exports = __webpack_public_path__ + "img/10889_L.1e655a83.png";